// extracted by mini-css-extract-plugin
export var container = "CartItem-module--container--TbSs0";
export var image = "CartItem-module--image--2Eyne";
export var description = "CartItem-module--description--FYpar";
export var quantity = "CartItem-module--quantity--PRRln";
export var remove = "CartItem-module--remove--1Lsr8";